import { ControlDocument } from "./control-document";

export class LinkedControlData {
    Id: number;
    Control: string;
    ControlSection: string;
    ControlSubSection: string;
    ReferenceText: string;
    Gaps: string;
    UserId: string;
    UserName: string;
    CreatedDateTime: Date;
  
    constructor() {
      this.Id = 0;
      this.Control = '';
      this.ControlSection = '';
      this.ControlSubSection = '';
      this.ReferenceText = '';
      this.Gaps = '';
      this.UserId = '';
      this.UserName = '';
      this.CreatedDateTime = new Date();
    }
  }